var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"mx-2",attrs:{"src":require('../../assets/images/icon-bar.png'),"max-height":"40","max-width":"40","contain":""}})}
var staticRenderFns = []

export { render, staticRenderFns }